module.exports = __webpack_public_path__ + "static/media/database.570a6e34.svg";